import React from 'react'
import { useEffect } from "react";
import { API_OPTIONS } from "../utils/Constants";
import { useDispatch } from "react-redux";
import { addClipDetails } from "../utils/detailsSlice";
const useMovieVidios = (movieId) => {
    const dispatch = useDispatch();

   
    const getMovieclip = async () => {
      const data = await fetch(
        "https://api.themoviedb.org/3/movie/"+ movieId +"/videos?language=en-US",
        API_OPTIONS
      );
      const json = await data.json();
      const filterdata = json?.results?.filter((video) => video.type === "Trailer");
      const trailer = filterdata?.length ? filterdata[0] : json?.results[0];
      
      dispatch(addClipDetails(trailer));
    };
  
    useEffect(() => {
      getMovieclip();
    }, []);
}

export default useMovieVidios